import React from "react";
import { Button, DatePicker, Panel } from "rsuite";
import { updateAdmin } from "../../store/modules/admin/actions";
import { useDispatch, useSelector } from "react-redux";
export default function DrawerLiveracaoAdminx() {
  const dispatch = useDispatch();

  const { components, reservations } = useSelector((state) => state.admin);

  function convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);

    var mySQLDate = [date.getFullYear(), month, day].join("-");
    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join("T");
  }

  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  const setHorario = (key, value) => {
    dispatch(
      updateAdmin({
        reservations: { ...reservations, [key]: value },
      })
    );
  };
  const verCarro = (carro) => {
    dispatch(
      updateAdmin({
        behavior: "Liverar",
      })
    );

    dispatch(
      updateAdmin({
        carro_Alugado: { ...carro },
      })
    );

    setComponent("header", false);
    setComponent("drawer", true);
  };

  return (
    <>
      <div className="   col-12 col-sd-12 col-md-12 col-xl-12  p-2 ">
        <div>
          <b className="text-white ">Calendario Liveração</b>
          <div className="d-flex flex-column  col-12 ">
            <DatePicker
              className="p-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              color="orange"
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("start_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />

            <DatePicker
              className="p-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("end_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />
          </div>
          <div className="d-flex flex-column justify-content-center">
            <button className="btn btn-success m-1 " onClick={""}>
              Pesquisar
            </button>
          </div>
        </div>
        <div className=" d-flex  flex-row flex-wrap  col-12 col-sd-12 col-md-12 col-xl-11  p-0 m-0  justify-content-center">
          {reservations.length > 0 ? (
            reservations.map((carro, index) => {
              return (
                <div
                  className=" text-white   block  rounded bg-dark m-3 text-center"
                  key={index}
                >
                  <Panel
                    className="m-1"
                    shaded
                    bordered
                    bodyFill
                    style={{ display: "inline-block", width: 240 }}
                  >
                    <img src={[]} height="240" />
                    <Panel>
                      <p>
                        <small>{}</small>
                      </p>
                      <p>
                        <small>{}</small>
                      </p>
                      <p>
                        <small>{}</small>
                      </p>
                      <p>
                        <small>{}</small>
                      </p>
                      <p>
                        <small>{}</small>
                      </p>
                      <div className=" col-12 text-center size-sm ">
                        <Button
                          appearance="primary"
                          color="green"
                          size="sm"
                          className="btn btn-success m-1  col-6 col-sd-12 col-xl-8 "
                          onClick={() => {
                            verCarro(carro);
                          }}
                        >
                          {" "}
                          Ver
                        </Button>
                      </div>
                    </Panel>
                  </Panel>
                </div>
              );
            })
          ) : (
            <h3>Escolha data de inicio e final</h3>
          )}
        </div>
      </div>
    </>
  );
}
